export { default } from './ThumbSelector';
